import { NormalizeOAS, OASRequestParams, OASResponse } from 'fets';
import type openapi from '../../../rest-api/openapi';
import { ApiClient } from '../../../rest-api/fetsClient';
import { SemanticVersion } from '../components/versioning/nextVersion';

const PATH = '/api/projects/{id}/course-exports';

type Params = {
  projectId: number;
};

type ProjectCourseExportVersion = {
  guid: string;
  version: SemanticVersion;
  description: string;
  createdAtTimestamp: number;
  isPublished: boolean;
};

export type ProjectCourseExport = {
  guid: string;
  name: string;
  versions: Array<ProjectCourseExportVersion>;
};

type Result = Array<ProjectCourseExport>;

export type ApiFunction = (params: Params, signal?: AbortSignal) => Promise<Result>;

export const createGetProjectCourseExports = (apiClient: ApiClient): ApiFunction => {
  const getProjectCourseExports = async (params: Params, signal?: AbortSignal): Promise<Result> => {
    const response = await apiClient[PATH].get({
      ...convertToRequest(params),
      ...(signal && { signal }),
    });

    return convertResponse(response);
  };

  return getProjectCourseExports;
};

type Request = OASRequestParams<NormalizeOAS<typeof openapi>, typeof PATH, 'get'>;
type Response = OASResponse<NormalizeOAS<typeof openapi>, typeof PATH, 'get'>;

const convertToRequest = (params: Params): Request => ({
  params: { id: params.projectId },
});

const convertResponse = async (response: Response): Promise<Result> => {
  const data = await response.json();
  return data.map((item) => ({
    guid: item.guid,
    name: item.name,
    versions: item.versions.map((version) => ({
      guid: version.guid,
      version: version.version,
      description: version.description,
      createdAtTimestamp: version.createdAtTimestamp,
      isPublished: version.isPublished,
    })),
  }));
};
